import CommissionType from 'src/features/finance/commissionStatement/constants/commissionType';
import ViewCommissionsPage from 'src/pages/ViewCommissionsPage/ViewCommissionsPage';

const ViewOnlineCommissionsPage = () => {
    return <ViewCommissionsPage commissionType={CommissionType.ONLINE} />;
};
export default ViewOnlineCommissionsPage;
